<template>
    <div class="hover-pointer hover-border" @click="open_edit_menu">

        <div class="or-admin-product-constructor-text hover-pointer hover-border">
            <div v-html="text" :style="options.style">
            </div>
        </div>

        <!-- <div class="edit" v-show="show_edit">
            <or-admin-textarea class="item" :options="options.text"/>
            <div class="input-container" v-for="(style, name) in options.style" :key="name">
                <p class='text'>{{style_titles[name]}}</p>
                <input v-show="!style_options[name]" type="text" class="input" v-model="options.style[name]" placeholder="name"/>
                <select v-show="style_options[name]" class="select" v-model="options.style[name]">
                    <option v-for="option in style_options[name]" :key="option">{{option}}</option>
                </select>
            </div>
            <p class="close hover-pointer hover-red" @click="show_edit = false">Закрыть</p>
        </div> -->
<!-- 
        <div v-show="show_edit_menu" class="edit-menu" ref="edit-menu">
            <img v-show="show_icon" class="edit-icon" @click="show_edit = true" src="../../../../assets/edit-icon.svg"/>
            <img v-show="show_icon" class="up-icon direction hover-pointer" @click="move_up" src="../../../../assets/up-icon.svg"/>
            <img v-show="show_icon" class="down-icon direction hover-pointer" @click="move_down" src="../../../../assets/down-icon.svg"/>
            <img v-show="show_icon" class="remove-icon direction hover-pointer" @click="delete_item" src="../../../../assets/delete-icon.svg"/>
        </div> -->

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import OrAdminTextarea from './or-admin-textarea.vue';
export default {
    components: {
        OrAdminTextarea
    },
    props: {
        options: Object,
    },
    data() {
        return {
            show_icon: true,
            show_edit: false,
            show_edit_menu: false,
            style_titles: {
                textAlign: 'Выравнивание текста',
                fontSize: 'Размер текста',
                fontWeight: 'Толщина текста',
                width: 'Ширина блока (%, px)',
                height: 'Высота блока (px)',
                minHeight: 'Минимальная высота блока (px)',
                paddingTop: 'Отступ сверху (%, px)',
                marginLeft: 'Отступ слева (%, px)',
                marginRight: 'Отступ справа (%, px)',
                marginBottom: 'Отступ снизу (%, px)',
                // justifyContent: 'Горизонтальное выравнивание блока',
                // alignItems: 'Вертикальное выравнивание блока',
            },
            style_options: {
                textAlign: [
                    'left',
                    'right',
                    'center'
                ],
                fontWeight: [
                    'normal',
                    'bold'
                ]
                // justifyContent: [
                //     'flex-start',
                //     'flex-end',
                //     'center'
                // ],
                // alignItems: [
                //     'center',
                //     'flex-start',
                //     'flex-end',
                // ],
            }
        }
    },
    computed: {
        ...mapGetters({getAdmin: 'getAdmin'}),
        text() {
            const div = document.createElement('div');
            this.convertText({text: this.options.text.value, container: div});
            return div.innerHTML;
        }
    },
    methods: {
        ...mapActions({
            convertText: 'convertText',
            addUnsavedPage: 'addUnsavedPage',
            changeAdmin: 'changeAdmin'}),
        open_edit_menu(e) {
        //     // const menu = this.$refs['edit-menu'];
        //     // menu.style.left = e.pageX + 'px';
        //     // menu.style.top = e.pageY + 'px';
        //     // this.show_edit_menu = true;
        //     if (this.getAdmin('edit_menu').show) {
                this.changeAdmin({property: 'edit_menu', value: {show: true, left: e.pageX + 'px', top: e.pageY + 'px', this_ctx: this}})
        //     }
        },     
        open_edit() {
            this.changeAdmin({property: 'edit_this', value: this});
            this.changeAdmin({property: 'type', value: 'text'});
            this.changeAdmin({property: 'show_inner_edit', value: false});
            this.changeAdmin({property: 'show_ceil_edit', value: false});
            this.changeAdmin({property: 'show_edit', value: true});
            this.changeAdmin({property: 'edit_menu', value: {show: false, left: 0, top: 0, this_ctx: null}})
        },
        close_edit() {
            this.changeAdmin({property: 'type', value: null});
            this.changeAdmin({property: 'show_edit', value: false});
        },
        delete_item() {
            this.$emit('delete_item');
            this.addUnsavedPage({page: 'products'})
            this.changeAdmin({property: 'edit_menu', value: {show: false, left: 0, top: 0, this_ctx: null}})
            this.changeAdmin({property: 'show_inner_edit', value: false});
            this.changeAdmin({property: 'show_ceil_edit', value: false});
            this.changeAdmin({property: 'show_edit', value: false});
        },
        move_up() {
            this.$emit('move_up');
            this.addUnsavedPage({page: 'products'})
        },
        move_down() {
            this.$emit('move_down');
            this.addUnsavedPage({page: 'products'})
        },
    }
}
</script>

<style scoped>
    .or-admin-product-constructor-text {
        position: relative;
    }
    .edit-icon {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 20px;
        height: 20px;
    }
    .edit {
        position: relative;
        width: 100%;    
        bottom: 0px;
        min-height: 100px;
        box-sizing: border-box;
        padding: 30px;
        background-color: white;
        color: black;
        border-radius: 0 0 8px 8px;
        font-size: 14px;
        line-height: 16px;
        z-index: 999999;
    }
    
    .direction {
        position: absolute;
        top: 15px;
        width: 20px;
        height: 20px;
    }
    .up-icon {
        right: 45px;
    }
    .down-icon {
        right: 75px;
    }
    .remove-icon {
        right: 105px;
    }
    .edit-menu {
        position: absolute;
        width: 260px;
        height: 40px;
        background-color: rgba(255,255,255,0.5);
        border-radius: 8px;
    }
</style>